/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Input, Typography } from 'antdV4';
import { Row, Col, DatePicker, Select, Checkbox } from 'antd';
import { ErrorMessage } from '@hookform/error-message';
import moment from 'moment';
import { ELegacySurveyType } from '../dto/legacy-survey-form.dto';
import fitSurvey2Services from '../../../../../services/fit-survey2.services';
import ImageUpload from '../../../fit-studio/components/upload/ImageUpload';

const LegacySurveyForm = () => {
  const {
    watch,
    reset,
    control,
    formState: { errors },
  } = useFormContext();

  fitSurvey2Services.useQueryGetLegacySurveyById(
    { surveyId: watch('id') },
    (data) => {
      reset({
        ...data,
        formType: 'edit',
        startDate: moment(data.startDate),
        endDate: moment(data.endDate),
      });
    }
  );

  return (
    <div>
      {watch('isPopUp') && (
        <Controller
          name="imageUrl"
          control={control}
          render={({ field: { value, onChange } }) => {
            return (
              <Row className="align-items-center mb-2">
                <Col span={24}>
                  <ImageUpload
                    value={value}
                    onChange={onChange}
                    width={200}
                    height={100}
                    errors={errors}
                  />
                </Col>
              </Row>
            );
          }}
        />
      )}
      <Controller
        name="title"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <Row className="align-items-center  mb-2">
              <Col span={4}>
                <Typography.Text>
                  หัวข้อ <span style={{ color: 'red' }}>*</span>
                </Typography.Text>
              </Col>
              <Col span={20}>
                <Input
                  value={value}
                  onChange={onChange}
                  placeholder="หัวข้อ"
                  maxLength={250}
                  showCount
                />
              </Col>
              <ErrorMessage
                errors={errors}
                name="title"
                render={({ message }) => (
                  <Typography.Text className="mb-2 text-danger">
                    {message}
                  </Typography.Text>
                )}
              />
            </Row>
          );
        }}
      />
      {watch('isPopUp') && (
        <Controller
          name="description"
          control={control}
          render={({ field: { onChange, value } }) => {
            return (
              <Row className="align-items-center  mb-2">
                <Col span={4}>
                  <Typography.Text>
                    คำอธิบาย <span style={{ color: 'red' }}>*</span>
                  </Typography.Text>
                </Col>
                <Col span={20}>
                  <Input.TextArea
                    value={value}
                    onChange={onChange}
                    placeholder="คำอธิบาย"
                    maxLength={250}
                    showCount
                  />
                  <div
                    style={{ display: 'flex', justifyContent: 'flex-end' }}
                  >{`${value.length} / 250`}</div>
                </Col>
                <ErrorMessage
                  errors={errors}
                  name="description"
                  render={({ message }) => (
                    <Typography.Text className="mb-2 text-danger">
                      {message}
                    </Typography.Text>
                  )}
                />
              </Row>
            );
          }}
        />
      )}
      <Controller
        name="startDate"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <Row className="align-items-center  mb-2">
              <Col span={4}>
                <Typography.Text>
                  วันที่เริ่มต้น <span style={{ color: 'red' }}>*</span>
                </Typography.Text>
              </Col>
              <Col span={20}>
                <DatePicker
                  format="DD/MM/YYYY HH:mm"
                  showTime={{ format: 'HH:mm' }}
                  className="w-100"
                  placeholder="วันที่เริ่มต้น"
                  allowClear={false}
                  value={value}
                  onChange={(date, dateString) => {
                    onChange(moment(date));
                  }}
                />
              </Col>
              <ErrorMessage
                errors={errors}
                name="start_date"
                render={({ message }) => (
                  <Typography.Text className="mb-2 text-danger">
                    {message}
                  </Typography.Text>
                )}
              />
            </Row>
          );
        }}
      />
      <Controller
        name="endDate"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <Row className="align-items-center  mb-2">
              <Col span={4}>
                <Typography.Text>
                  วันที่สิ้นสุด <span style={{ color: 'red' }}>*</span>
                </Typography.Text>
              </Col>
              <Col span={20}>
                <DatePicker
                  format="DD/MM/YYYY HH:mm"
                  showTime={{ format: 'HH:mm' }}
                  className="w-100"
                  placeholder="วันที่สิ้นสุด"
                  value={value}
                  allowClear={false}
                  onChange={(date, dateString) => {
                    onChange(moment(date));
                  }}
                />
              </Col>
              <ErrorMessage
                errors={errors}
                name="end_date"
                render={({ message }) => (
                  <Typography.Text className="mb-2 text-danger">
                    {message}
                  </Typography.Text>
                )}
              />
            </Row>
          );
        }}
      />
      <Controller
        name="memberType"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <Row className="align-items-center  mb-2">
              <Col span={4}>
                <Typography.Text>
                  ประเภทนักธุรกิจ <span style={{ color: 'red' }}>*</span>
                </Typography.Text>
              </Col>
              <Col span={20}>
                <Select
                  value={value}
                  style={{ width: '100%' }}
                  onChange={onChange}
                >
                  {ELegacySurveyType.map((item) => {
                    return (
                      <Select.Option key={item.value} value={item.value}>
                        {item.label}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Col>
              <ErrorMessage
                errors={errors}
                name="rewardId"
                render={({ message }) => (
                  <Typography.Text className="mb-2 text-danger">
                    {message}
                  </Typography.Text>
                )}
              />
            </Row>
          );
        }}
      />
      <Controller
        name="point"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <Row className="align-items-center  mb-2">
              <Col span={4}>
                <Typography.Text>
                  หัวใจที่ได้รับ <span style={{ color: 'red' }}>*</span>
                </Typography.Text>
              </Col>
              <Col span={20}>
                <Input
                  value={value}
                  onChange={onChange}
                  placeholder="หัวใจที่ได้รับ"
                  rows={2}
                  type="number"
                />
              </Col>
              <ErrorMessage
                errors={errors}
                name="point"
                render={({ message }) => (
                  <Typography.Text className="mb-2 text-danger">
                    {message}
                  </Typography.Text>
                )}
              />
            </Row>
          );
        }}
      />
      <Controller
        name="isPopUp"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <Row className="align-items-center  mb-2">
              <Col span={4}>
                <Typography.Text>แบบ Pop Up</Typography.Text>
              </Col>
              <Col span={20}>
                <Checkbox
                  checked={value}
                  onChange={(value) => {
                    onChange(value);
                  }}
                  style={{ marginRight: 5 }}
                />
              </Col>
            </Row>
          );
        }}
      />
    </div>
  );
};

export default LegacySurveyForm;
